import React from "react";
import { useEffect } from "react";
import { useState } from "react";
// import { getAPIUrl, getAPIUrlBM } from "./config";
// import backLinkgetCall from "../Apis/backlink/Get";
import { getAPIUrlBM } from "../../utils/config";
import backLinkgetCall from "../../Apis/backlink/Get";
import loadingGif from "../src/Assets/loading.gif";

const RouteChecker = ({ children, url }) => {
  const [authentic, setAuthentic] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const CheckAccess = async () => {
      try {
        const URL = getAPIUrlBM();
        // console.log({url : URL + "/" + url})
        const res = await backLinkgetCall(URL + "/" + url);

        // console.log({routeChecker : res})
        if (res.visible) {
          setLoading(false);
          setAuthentic(true);
        } else {
          setLoading(false);
          if (url === "userApiKeyScreen") {
            window.sweet({
              title: "You don't have access to this page ",
              text: "Please contact your administrator to add the API keys or give you access to this section to be able to Add API Keys.",
              icon: "warning",
            });
          }
        }
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    };
    CheckAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  return (
    <>
      {!loading ? (
        <>
          {authentic ? (
            children
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div>
                You don't have access to this route. please ask for permissions
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "89vh",
            margin: "-15px -30px",
          }}
        >
          <img
            style={{
              width: "82vw",
              height: "94vh",
            }}
            alt=""
            src={loadingGif}
          />
        </div>
      )}
    </>
  );
};

export default RouteChecker;
